import axios from "../utils/apiClient";
import {dataFetchHelper} from "./baseDataFetch";
import {TRACK_EVENTS, trackPendoEvent} from "../utils/pendoTrack";

const baseURL = process.env.REACT_APP_REST_API_BASE_URL;

const [getAssessmentFormTemplates, useGetAssessmentFormTemplates] = dataFetchHelper(([client]) => {
  const sanitizedClientId = encodeURIComponent(client);
  return axios.get(
    `${baseURL}/v1/assessments/form-template?client=${sanitizedClientId}`,
    {
      headers: {},
    }
  );
});

const saveAssessmentTemplate = (carePathTemplate) => {
  return axios.post(
    `${baseURL}/v1/assessments/form-template`,
    carePathTemplate,
    {
      headers: {},
    }
  ).then((response) => {
    trackPendoEvent(TRACK_EVENTS.ADMIN_ASSESSMENT_TEMPLATE_SAVE, {
      route: window?.location?.pathname,
      source_module: "assessmentTemplate.saveAssessmentTemplate",
      template_id: response?.data || carePathTemplate?.id
    });
    return response;
  });
};

const deleteAssessmentTemplate = (id) => {
  const sanitizedId = encodeURIComponent(id);
  return axios.delete(
    `${baseURL}/v1/assessments/form-template?id=${sanitizedId}`,
    {
      headers: {},
    }
  );
};

export {
  getAssessmentFormTemplates,
  useGetAssessmentFormTemplates,
  saveAssessmentTemplate,
  deleteAssessmentTemplate
};
